import React from 'react';
import { CelebrationOverlayProps } from '../../../presentation/GamePresentationTypes';
import { BostonCelebrationOverlay } from '../../../components/Celebration/BostonCelebrationOverlay';

/**
 * Spades-specific Hand-End Celebration Overlay.
 *
 * Owned exclusively by the Spades module:
 * Activates when a team scores a Boston / Clean Sweep (all 13 books),
 * rendering cascading sparks and fireworks (WITHOUT the Bid Whist Boston train).
 */
export const SpadesCelebrationOverlay: React.FC<CelebrationOverlayProps> = ({
  isOpen,
  isUserTeam = true,
}) => {
  return (
    <BostonCelebrationOverlay
      isOpen={isOpen}
      isUserTeam={isUserTeam}
    />
  );
};
